import React, { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import interactionResponse from 'await-interaction-response';
import _get from 'lodash/get';
import _set from 'lodash/set';

import { useDevice } from '@bonnet/next/device';

import { pageNames } from '@atc/bonnet-paths';
import { useFeatures } from '@atc/features';

import { sendClick } from 'reaxl-analytics';

import { hideAdClick } from '@/analytics/srp/hideAdEvents';

import adUnits from '@/config/adUnits';

import srpAdsDuck from '@/ducks/srp/srpAdsDuck';
import srpFooterAdDuck from '@/ducks/srp/srpFooterAdDuck';

import AtcAdSlot from '@/containers/AtcAdSlot';
import DisableAdsFeatureFlag from '@/containers/global/DisableAdsFeatureFlag';

import HideAdButton from '@/components/HideAdButton';

const backFillSize = [320, 50];
const { SEARCH_RESULTS } = pageNames;

export function FooterLeaderAdSlotContainer() {
    const device = useDevice();

    const {
        srp_ads_single_size: [isSingleSizeOnly],
        enable_hide_ad: [enableHideAd],
    } = useFeatures(['srp_ads_single_size', 'enable_hide_ad']);

    const dispatch = useDispatch();
    const hideFooterAd = useSelector(srpFooterAdDuck.selectors.getHideFooterAd);
    const adsLazyLoadingOffset = useSelector(srpAdsDuck.selectors.getAdsLazyLoadingOffset);

    const handleHideFooterAd = useCallback(async (event) => {
        const eventTarget = _get(event, 'target.value', null);
        await interactionResponse();
        _set(event, 'target.value', eventTarget);

        const extra = {
            adType: 'Footer Leader Ad',
        };
        sendClick(hideAdClick, event, extra);
        dispatch(srpFooterAdDuck.creators.setKeys({
            hideFooterAd: true,
        }));
    }, [dispatch]);

    // ensure ad sizes are in order from shortest to tallest to make sure min size is smallest height
    const extraSmallSize = isSingleSizeOnly ? [backFillSize] : [backFillSize, [320, 250]];
    const normalSize = [[728, 90]];

    const isXs = _get(device, 'is.xs', false);
    const size = isXs ? extraSmallSize : normalSize;

    const targeting = {
        anml: 'N',
        pos: 'e',
        prd: 'dlr',
    };

    const path = `${adUnits?.atcFindcar}/srp`;

    if (enableHideAd && hideFooterAd) {
        return null;
    }

    return (
        <DisableAdsFeatureFlag>
            <AtcAdSlot
                className="display-flex flex-column justify-content-center"
                lazyLoading
                lazyLoadingBottomOffset={adsLazyLoadingOffset}
                lazyLoadingTopOffset={adsLazyLoadingOffset}
                path={path}
                preserveSpace
                showPlaceholder
                size={size}
                slotId="footerLeader"
                targeting={targeting}
                adSelector={srpAdsDuck.selectors.getDuckState}
                pageName={SEARCH_RESULTS}
                advertisementLabel={{
                    className: 'display-flex justify-content-end',
                    text: 'Advertisement',
                    enableHide: enableHideAd,
                    hideButton: HideAdButton,
                    onClickHide: handleHideFooterAd,
                }}
            />
        </DisableAdsFeatureFlag>
    );
}

export default FooterLeaderAdSlotContainer;
